import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en', // язык по умолчанию
    fallbackLng: 'en',
    resources: {}, // изначально пустой словарь
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false // отключаем suspense, чтобы всё было проще
    }
  });

export default i18n;
